<div class="task-delivery"
[ngClass]="variant === 'inline' ? 'p-4 lg:p-6 m-auto w-[96%] md:w-10/12 rounded-lg bg-white shadow-[rgba(0,0,0,0.12)_0px_1px_3px,rgba(0,0,0,0.24)_0px_1px_2px]' : 'w-full'"
>
  <!-- cargando: mismos esqueletos que el modal de producción -->
  <div *ngIf="phase === 'loading'" class="flex flex-col gap-6">
    <ion-skeleton-text [animated]="true" class="w-26 h-3 rounded-lg"></ion-skeleton-text>
    <div class="flex flex-col gap-4">
      <div class="flex gap-4" *ngFor="let row of [0, 1, 2, 3]">
        <ion-skeleton-text [animated]="true" class="w-full h-3 rounded-lg"></ion-skeleton-text>
      </div>
    </div>
    <ion-skeleton-text [animated]="true" class="w-full h-11 rounded-lg"></ion-skeleton-text>
    <div class="flex gap-4">
      <ion-skeleton-text [animated]="true" class="w-9/12 h-10 rounded-lg"></ion-skeleton-text>
      <ion-skeleton-text [animated]="true" class="w-3/12 h-10 rounded-lg"></ion-skeleton-text>
    </div>
  </div>

  <!-- la tarea no pudo cargarse -->
  <div *ngIf="phase === 'error'" class="flex flex-col items-center gap-3 text-center text-gray-700 py-6">
    <p class="text-base">{{ errorMsg }}</p>
    <ion-button fill="outline" size="small" (click)="load()">Reintentar</ion-button>
  </div>

  <ng-container *ngIf="task && phase !== 'loading' && phase !== 'error'">
    <!-- encabezado -->
    <div class="flex flex-col gap-1 mb-3" *ngIf="courseName || statusLabel">
      <p *ngIf="courseName" class="text-sm text-gray-600">{{ courseName }}</p>
      <p *ngIf="statusLabel" class="text-base font-bold">
        <span class="text-secondary mr-2">Estado:</span>{{ statusLabel }}
      </p>
    </div>

    <!-- acordeón: Indicaciones / Recursos / Documentos / Comentarios -->
    <div class="flex flex-col divide-y divide-gray-200 border-y border-gray-200 mb-4">
      <div [ngClass]="openSection === 'indicaciones' ? 'rounded-lg px-1 bg-primary_super_ultra_light_variant' : ''">
        <button type="button" class="task-delivery__header" (click)="toggleSection('indicaciones')">
          <span class="text-primary text-lg font-medium">Indicaciones</span>
          <mat-icon class="mdi mdi-chevron-down text-xl text-primary transition-transform duration-200"
            [class.rotate-180]="isOpen('indicaciones')"></mat-icon>
        </button>
        <div *ngIf="isOpen('indicaciones')" class="pb-3 px-1">
          <p class="text-base font-normal whitespace-pre-line">
            {{ task.indications || 'Aquí encontrarás todos los recursos para realizar y subir tu tarea.' }}
          </p>
        </div>
      </div>

      <div [ngClass]="openSection === 'recursos' ? 'rounded-lg px-1 bg-primary_super_ultra_light_variant' : ''">
        <button type="button" class="task-delivery__header" (click)="toggleSection('recursos')">
          <span class="text-primary text-lg font-medium">Recursos de la tarea</span>
          <mat-icon class="mdi mdi-chevron-down text-xl text-primary transition-transform duration-200"
            [class.rotate-180]="isOpen('recursos')"></mat-icon>
        </button>
        <div *ngIf="isOpen('recursos')" class="pb-3 px-1">
          <ul *ngIf="task.project_resources?.length; else noTaskResources" class="flex flex-col">
            <li *ngFor="let resource of task.project_resources" class="flex items-center justify-between gap-3 py-2">
              <p class="text-base break-words min-w-0">{{ resource.title }}</p>
              <button type="button" class="shrink-0 text-primary" (click)="confirmDownload(resource)"
                [attr.aria-label]="'Descargar ' + resource.title">
                <mat-icon class="mdi mdi-download text-2xl"></mat-icon>
              </button>
            </li>
          </ul>
          <ng-template #noTaskResources>
            <p class="text-base text-gray-600 py-2">Esta sección no contiene recursos asignados.</p>
          </ng-template>
        </div>
      </div>

      <div [ngClass]="openSection === 'documentos' ? 'rounded-lg px-1 bg-primary_super_ultra_light_variant' : ''">
        <button type="button" class="task-delivery__header" (click)="toggleSection('documentos')">
          <span class="text-primary text-lg font-medium">Documentos cargados</span>
          <mat-icon class="mdi mdi-chevron-down text-xl text-primary transition-transform duration-200"
            [class.rotate-180]="isOpen('documentos')"></mat-icon>
        </button>
        <div *ngIf="isOpen('documentos')" class="pb-3 px-1">
          <ul *ngIf="userResources.length; else noUploadedTask" class="flex flex-col">
            <li *ngFor="let resource of userResources; let i = index"
              class="flex items-center justify-between gap-3 py-2">
              <span class="text-base font-medium break-words min-w-0">
                {{ resourceName(resource) }} ({{ sizeMb(resource) }}MB)
              </span>
              <div class="flex items-center gap-3 shrink-0">
                <span class="rounded-lg border h-6 px-2 flex items-center gap-1 text-base"
                  [ngClass]="isStored(resource) || isSending ? 'border-primary text-primary' : 'border-secondary text-secondary'">
                  <span>{{ isStored(resource) ? 'Cargado' : isSending ? 'Cargando' : 'Da clic en enviar' }}</span>
                  <mat-icon *ngIf="isStored(resource)" class="mdi mdi-check-bold text-base"></mat-icon>
                </span>
                <button *ngIf="!isDelivered" type="button" class="text-primary text-3xl disabled:opacity-50"
                  [disabled]="isSending" (click)="removeResource(i)" aria-label="Quitar archivo">
                  <mat-icon class="mdi mdi-delete"></mat-icon>
                </button>
              </div>
            </li>
          </ul>
          <ng-template #noUploadedTask>
            <p class="text-base text-gray-600 py-2">En esta sección se listarán los archivos que agregues a tu tarea.</p>
          </ng-template>
        </div>
      </div>

      <div *ngIf="task.msg_to_user">
        <button type="button" class="task-delivery__header" (click)="toggleSection('comentarios')">
          <span class="text-primary text-lg font-medium">Comentarios</span>
          <mat-icon class="mdi mdi-chevron-down text-xl text-primary transition-transform duration-200"
            [class.rotate-180]="isOpen('comentarios')"></mat-icon>
        </button>
        <div *ngIf="isOpen('comentarios')" class="pb-3 px-1">
          <p class="text-base font-normal whitespace-pre-line">{{ task.msg_to_user }}</p>
        </div>
      </div>
    </div>

    <!-- envío -->
    <div class="flex flex-col gap-3">
      <p *ngIf="errorMsg" class="text-sm text-red-600 text-center" role="alert">{{ errorMsg }}</p>
      <p *ngIf="successMsg" class="text-sm text-primary font-medium text-center" role="status">{{ successMsg }}</p>
      <p *ngIf="isDelivered && !successMsg" class="text-sm text-gray-600 text-center">Ya enviaste tu tarea.</p>

      <div class="flex items-center gap-2" *ngIf="canUpload">
        <ion-button class="w-9/12 normal-text" fill="outline" type="button" [disabled]="!canAddFile || isSending"
          (click)="fileInput.click()">
          <ion-icon name="add-circle" class="w-5 mr-1"></ion-icon>
          <span class="text-base font-semibold">Subir archivo</span>
        </ion-button>
        <input #fileInput type="file" class="hidden" [accept]="acceptTypes" (change)="onFileSelected($event)" />

        <ion-button class="w-3/12" type="button" color="primary" [disabled]="!canSend" (click)="send()">
          <span class="text-white text-base font-semibold">Enviar</span>
        </ion-button>
      </div>

      <ion-button *ngIf="!canUpload" class="w-full" type="button" color="primary" [disabled]="!canSend" (click)="send()">
        <span class="text-white text-base font-semibold">Enviar</span>
      </ion-button>
    </div>
  </ng-container>
</div>
